import { apiFetch } from "../api/apiFetch.js";

export async function getJson(path, init) {
  const res = await apiFetch(path, init);

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(
      `${path} failed: ${res.status} ${res.statusText}${
        text ? ` — ${text.slice(0, 200)}` : ""
      }`
    );
  }

  const ct = (res.headers.get("content-type") || "").toLowerCase();
  if (!ct.includes("application/json")) {
    const sample = await res.text().catch(() => "");
    throw new Error(
      `${path} did not return JSON (got "${ct}"). Sample: ${sample.slice(0, 200)}`
    );
  }

  return res.json();
}
